import { styled } from "styled-components";
import { rgba } from "polished";
const ItemChildren = styled("div")(() => ({
  paddingLeft: 24
}));
styled("div")(({ theme }) => ({
  position: "absolute",
  left: -8,
  width: 8,
  minWidth: 8,
  maxWidth: 8,
  height: 36,
  backgroundColor: "red",
  lineHeight: theme.lineHeight.default
}));
const ItemGroup = styled("div")(() => ({
  position: "relative"
}));
const ItemPrefixAction = styled("div")(() => ({
  display: "inline-flex",
  flexBasis: "auto",
  marginLeft: -4,
  marginRight: 4
}));
const ItemAction = styled("div")(() => ({
  display: "inline-flex",
  flexBasis: "auto",
  paddingRight: 4
}));
const ItemActions = styled("div")(() => ({
  display: "inline-flex",
  flexBasis: "auto",
  paddingLeft: 8,
  marginRight: -8
}));
const ItemIcon = styled("div")(
  () => ({
    display: "inline-flex",
    flexBasis: "auto",
    paddingRight: 8
  }),
  ({ $disabled, theme, variant }) => $disabled ? { color: theme.color.gray6 } : {
    color: variant === "accent" ? theme.color.blue6 : theme.color.gray8
  }
);
const ItemSuffixIcon = styled("div")(
  () => ({
    display: "inline-flex",
    flexBasis: "auto"
  }),
  ({ $disabled, theme, variant }) => $disabled ? { color: theme.color.gray6 } : {
    color: variant === "accent" ? theme.color.blue6 : theme.color.gray8
  }
);
const CollapseItemIcon = styled("div")(({ theme }) => ({
  display: "inline-flex",
  flexBasis: "auto",
  paddingRight: 8,
  fontSize: theme.fontSize.default,
  color: theme.color.gray6
}));
const Item = styled("div")(
  () => ({
    display: "flex",
    position: "relative",
    height: 32,
    paddingLeft: 8,
    paddingRight: 8,
    borderRadius: 2,
    alignItems: "center",
    border: 0,
    outline: 0,
    transition: "all 0.1s cubic-bezier(.645, .045, .355, 1)"
  }),
  ({ $clickable }) => $clickable ? { cursor: "pointer" } : { cursor: "default" },
  ({ theme, $clickable, "aria-disabled": disabled, variant }) => !$clickable || disabled ? {
    fontWeight: theme.fontWeight.normal
  } : {
    default: {
      fontWeight: theme.fontWeight.normal,
      "&:hover": {
        backgroundColor: theme.color.gray3
      },
      "&:focus": {
        boxShadow: `0 0 0 2px ${rgba("black", 0.05)}`,
        zIndex: 1
      },
      "&:active": {
        backgroundColor: theme.color.gray4
      }
    },
    focused: {
      fontWeight: theme.fontWeight.normal,
      backgroundColor: theme.color.monochrome2,
      "&:hover": {
        backgroundColor: theme.color.gray3
      },
      "&:focus": {
        boxShadow: `0 0 0 2px ${rgba("black", 0.05)}`,
        zIndex: 1
      },
      "&:active": {
        backgroundColor: theme.color.gray4
      }
    },
    accent: {
      backgroundColor: theme.color.blue1,
      fontWeight: theme.fontWeight.medium,
      "&:hover": {
        backgroundColor: theme.color.blue2
      },
      "&:focus": {
        boxShadow: `0 0 0 2px ${rgba(theme.color.blue6, 0.25)}`,
        zIndex: 1
      },
      "&:active": {
        backgroundColor: theme.color.blue3
      }
    },
    danger: {
      backgroundColor: theme.color.red1,
      "&:hover": {
        backgroundColor: theme.color.red2
      },
      "&:focus": {
        boxShadow: `0 0 0 2px ${rgba(theme.color.red6, 0.25)}`,
        zIndex: 1
      },
      "&:active": {
        backgroundColor: theme.color.red3
      }
    }
  }[variant],
  ({ theme, "aria-disabled": disabled }) => disabled ? {
    background: "none",
    color: theme.color.gray6,
    "&:focus": {
      boxShadow: `0 0 0 2px ${rgba("black", 0.05)}`,
      zIndex: 1
    }
  } : {}
);
const ItemContent = styled("div")(
  ({ theme, header }) => ({
    flexGrow: 1,
    flexShrink: 1,
    background: "none",
    border: 0,
    boxSizing: "border-box",
    color: header ? theme.color.gray9 : theme.color.gray8,
    display: "block",
    fontWeight: header ? theme.fontWeight.medium : theme.fontWeight.normal,
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    lineHeight: theme.lineHeight.default,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    outline: 0,
    textAlign: "left",
    textDecoration: "none"
  }),
  ({ theme, $disabled, variant }) => $disabled ? {} : {
    accent: {
      fontWeight: theme.fontWeight.medium,
      color: theme.color.blue6
    }
  }[variant],
  ({ theme, $disabled }) => $disabled ? {
    color: theme.color.gray6
  } : {}
);
export {
  CollapseItemIcon,
  Item,
  ItemAction,
  ItemActions,
  ItemChildren,
  ItemContent,
  ItemGroup,
  ItemIcon,
  ItemPrefixAction,
  ItemSuffixIcon
};
